/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {shallowEqual, useSelector, useDispatch} from 'react-redux'
import {Link} from 'react-router-dom'
import {UserModel} from '../../../../app/modules/auth/models/UserModel'
import {RootState} from '../../../../setup'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import {toAbsoluteUrl} from '../../../helpers'
import MsalService from '../../../../app/modules/auth/azure/MsalService'
import {useMsal} from '@azure/msal-react'

const HeaderUserMenu: FC = () => {
  const {user, displayName} = useSelector<RootState, {user?: UserModel; displayName?: string}>(
    ({auth}) => ({user: auth.user, displayName: auth.displayName}),
    shallowEqual
  )
  const {logoutAzureAccount} = MsalService()
  const {accounts} = useMsal()
  const dispatch = useDispatch()
  const fullName = [user?.firstName, user?.lastName].filter(Boolean).join(' ').trim()
  const userLabel = fullName || user?.fullname || displayName || user?.email || 'Account'

  const logout = () => {
    if (accounts.length > 0) {
      logoutAzureAccount()
    } else {
      dispatch(auth.actions.logout())
    }
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/blank.jpg')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {userLabel}
            </div>
            {user?.email && (
              <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
                {user.email}
              </a>
            )}
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5 my-1'>
        <Link to={'/crafted/pages/profile'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}

